if (!customElements.get("language-switcher")) {
  class LanguageSwitcher extends HTMLElement {
    constructor() {
      super();

      this.languageSelect = this.querySelector("#language-switcher-select");
      this.currencySelect = this.querySelector(
        "#language-switcher-currency-select"
      );

      this.languageSelect.addEventListener("change", (e) => {
        const url = this.languageSelect
          .querySelector(`[value="${e.target.value}"]`)
          .getAttribute("data-url");
        window.location.href = url;
      });

      this.currencySelect.addEventListener("change", (e) => {
        console.log("e.target.value", e.target.value);
        const form = this.querySelector("#currency_form");
        form.querySelector("input[name='currency']").value = e.target.value;
        form.submit();
      });
    }
  }

  customElements.define("language-switcher", LanguageSwitcher);
}
